import {
  getAnchorButtonUrlProps,
  toSlug,
  trackAnalytics,
} from '../utils';
import type { AnalyticsTags } from '../utils';
import type { Locale } from '../locale';

type Button = {
  label?: string | null; href?: string | null; descriptiveText?: string | null;
  openInNewTab?: boolean | null; variant?: string | null; size?: string | null; theme?: string | null;
};
type ButtonFallback = {
  buttonText?: string; accessibleLabel?: string; variant?: string; size?: string; theme?: string;
};

export const mapBackendButtonToFEButton = ({
  button = null,
  locale = 'en',
  analyticsParentId = '',
  analyticsTags = null,
  fallback = {},
}: {
  button?: Button | null; locale?: Locale; analyticsParentId?: string;
  analyticsTags?: AnalyticsTags | null; fallback?: ButtonFallback;
}) => {
  if (!button) {
    return null;
  }

  const {
    label,
    href,
    descriptiveText,
    openInNewTab,
    variant,
    size,
    theme,
  } = button;

  const {
    buttonText: fallbackButtonText = '',
    accessibleLabel: fallbackAccessibleLabel = '',
    variant: fallbackVariant = 'secondary',
    size: fallbackSize = 'medium',
    theme: fallbackTheme = 'light',
  } = fallback;

  const { url } = getAnchorButtonUrlProps(href, locale);
  const buttonText = label || fallbackButtonText;
  const accessibleLabel = descriptiveText || fallbackAccessibleLabel;
  const analytics = analyticsParentId && buttonText
    ? trackAnalytics(
      analyticsParentId,
      `${toSlug(buttonText)}-${analyticsParentId}`,
      url || '',
      analyticsTags,
    )
    : {};

  return {
    buttonText,
    accessibleLabel,
    url,
    variant: variant || fallbackVariant,
    size: size || fallbackSize,
    theme: theme || fallbackTheme,
    ...(openInNewTab ? { target: '_blank' } : {}),
    ...analytics,
  };
};
